import { Utils, Constants } from "@zanichelli/myz-react-utils";

const request = new Utils.Request(Constants.ENV.API_V3_URL);

export const get = request.get;
export const post = request.post;
export const update = request.update;
export const patch = request.patch;
export const remove = request.remove;
